import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Layout } from "../components/Layout";

export default function PaymentCancel() {
  return (
    <Layout>
      <div className="max-w-lg mx-auto px-5 py-32 text-center">
        <XCircle size={56} className="text-eon-muted mx-auto" />
        <h1 className="eon-heading text-4xl uppercase mt-6">Payment Cancelled</h1>
        <p className="text-eon-muted mt-3">No charge was made. You can return and try again anytime.</p>
        <div className="flex gap-3 justify-center mt-8">
          <Link to="/shop" className="bg-eon-gold text-white text-sm font-bold uppercase tracking-wider px-6 py-3 hover:bg-eon-goldhover transition-colors">Back to Shop</Link>
          <Link to="/" className="border border-eon-border text-eon-text text-sm font-bold uppercase tracking-wider px-6 py-3 hover:border-eon-gold transition-colors">Home</Link>
        </div>
      </div>
    </Layout>
  );
}
